module.exports = __webpack_public_path__ + "img/close.03ef14fc.svg";